import {HttpInterceptorFn, HttpResponse} from '@angular/common/http';
import {RequestHeaders} from "../enum/request-headers";
import {LoadingIndicatorService} from "../shared/loading-indicator/loading-indicator.service";
import {inject} from "@angular/core";
import {tap} from "rxjs";

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.headers.get(RequestHeaders.SUPPRESS_LOADING) == 'true') {
    return next(req)
  }

  const loadingService: LoadingIndicatorService = inject(LoadingIndicatorService)
  loadingService.showLoader();

  return next(req).pipe(tap({
    next: event => {
      if (event instanceof HttpResponse) {
        loadingService.hideLoader();
      }
    },
    error: error => {
      loadingService.hideLoader();
      throw error;
    }
  }))
};
